// src/shared/components/common/toaster.tsx

import { Toaster as SonnerToaster } from 'sonner'

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      expand={false}
      offset={16}
      toastOptions={{
        classNames: {
          toast:
            'rounded-md border border-[var(--panel-border)] bg-[var(--panel)] text-[var(--color-text)] shadow-md',
          title: 'font-medium text-sm',
          description: 'text-xs text-[var(--color-text-soft)]',
          actionButton: 'rounded-md bg-[var(--color-brand)] text-[var(--color-brand-fg)]',
          cancelButton: 'rounded-md text-[var(--color-text-soft)]',
        },
      }}
    />
  )
}
